<script setup lang="ts">
import SeminarDetailTemplate from '~/components/templates/SeminarDetailTemplateV2/SeminarDetailTemplate.vue';

const route = useRoute();

const _seminarId = computed(() => {
  const _id = route.params.id;
  if (!route.params.id || Array.isArray(_id)) {
    throw createError({ statusCode: 404 });
  }
  const id = parseInt(_id, 10);
  if (!Number.isInteger(id)) {
    throw createError({ statusCode: 404 });
  }
  return id;
});
</script>

<template>
  <SeminarDetailTemplate />
</template>

<style module lang="scss"></style>
